class ReservedProductRemoveButton extends HTMLElement {
  connectedCallback() {
    this.lineItemCard = this.closest('.line-item-card');
    if (!this.lineItemCard) return;

    this.handleClick = this.handleClick.bind(this);
    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }

  handleClick() {
    const { lineItemId } = this.lineItemCard.dataset;
    if (!lineItemId) return;

    publish('product-removed', { lineItemId });
  }
}

customElements.define('reserved-product-remove-button', ReservedProductRemoveButton);
